<div class="panel-body alert-details-body flex-column flex-fill">
  <!--Tabs-->
  <ukg-card has-border non-actionable>
    <div class="alerts-tab-set flex-row">
      <div *ngFor='let counts of tabCounts' [ngClass]="getTabStyleClass(counts.category)" (click)="tabSelected($event, counts.category)" class="flex">
        <ukg-card-content class="text-left">
          <div class="header-position">
          <small class="text-muted" data-automation="total_unacknowledged_alerts_count">
            {{counts.category | enum:'CustomerNotificationCategory'}} 
          </small><ukg-icon name="help" (click)="tabTooltip.present($event.target)" class="heading-icon-spacing" data-automation="notification_tab_tooltip"></ukg-icon>
          </div>
          <strong class="text-color" data-automation="filtered_alerts_count">
            {{counts.unAcknowledged}} <span *ngIf="!counts.isRefreshing && counts.isFiltered" class="text-muted">({{'ALERTS.FILTERED_RESULTS' | translate:{filterCount: counts.filtered} }})</span>
          </strong>
        </ukg-card-content>
        <ukg-popover #tabTooltip fixedHeight="large">
          <div style="white-space: normal;" data-automation="common_tooltip_text">{{ getCategoryTooltip(counts.category) | translate }}</div>
        </ukg-popover>
      </div>
    </div>
  </ukg-card>
  <br />
  <!--Message Bar-->
  <ssg-notification-bar [userMessages]="userMessages" [notification]="notificationSubject.asObservable()" pageKey="alert-details"></ssg-notification-bar>
  <div [ngClass]="enableAlertDetailsNachaAuditInfo && areAnyNotifications() ? 'nav-bar' : 'nav-bar-filter'">
    <ukg-button [emphasis]="'mid'" [size]="'medium'" *ngIf="enableAlertDetailsNachaAuditInfo && areAnyNotifications()"  data-automation="alerts_export_btn" (click)="exportAlerts()"  translate>
      COMMON.BUTTON_EXPORT
    </ukg-button>
  <!--Filters Button-->
  <ssg-side-filter (apply)="applyFilter()" (reset)="resetFilter()" [isInvalid]="!editFilters.isValid">
    <div class="form-group comp-spacing fontstyling">
      <ukg-label class="text-muted" data-automation="pay_date_alerts_edit_label" translate>ALERTS.PAYDATE_LABEL</ukg-label>
      <ssg-date-picker [(ngModel)]="editFilters.payDate" [minDate]="editFilters.minDate" (invalidDateChanged)="editFilters.isPayDateInvalid = $event" justify="right" nullable="true" data-automation="pay_date_alerts_date_picker"></ssg-date-picker>
    </div>
    <div class="form-group comp-spacing">
      <ukg-input-container [block]="true">
      <div class="text-muted" data-automation="paygroup_alerts_edit_label" translate>ALERTS.PAYGROUP_LABEL</div>
        <ukg-select searchPlaceholder="{{ 'ALERTS.SEARCH_PLACEHOLDER' | translate}}" data-automation="pay_group_alerts_edit_dropdown" placeholder="{{ 'ALERTS.PAYGROUP_PLACEHOLDER' | translate}}" [disabled]="!allPayGroups.length"
         [multiple]="true" [(ngModel)]="editFilters.payGroups" bindLabel="code">
          <ukg-select-option *ngFor="let item of allPayGroups"  [value]="item" [label]="item.code" ></ukg-select-option>
        </ukg-select>
      </ukg-input-container>
    </div>
    <div class="form-group comp-spacing fontstyling">
      <div class="text-muted" data-automation="fund_type_edit_label" translate>ALERTS.FUND_FILTER_LABEL</div>
      <div class="text-muted" data-automation="fund_type_type_label" translate>ALERTS.FUND_FILTER_TYPE_LABEL</div>
      <div class="checkboxes-container">
        <div class="checkbox-container">
          <ukg-label for="fundsReturned" translate data-automation="funds_returned_alert_type_label">
            <ukg-checkbox [disabled]="false" [fullWidth]="false" [roundedCorners]="true" translate id="fundsReturned" [(ngModel)]="editFilters.hasFundTypeReturned" data-automation="funds_returned_alert_type_checkbox">
            ALERTS.FUNDS_RETURNED</ukg-checkbox>
          </ukg-label>
        </div>
        <div class="checkbox-container">
          <ukg-label for="fundsNotReturned" translate data-automation="funds_not_returned_alert_type_label">
            <ukg-checkbox [disabled]="false" [fullWidth]="false" [roundedCorners]="true" translate id="fundsNotReturned" [(ngModel)]="editFilters.hasFundTypeNotReturned" data-automation="funds_not_returned_alert_type_checkbox">
            ALERTS.FUNDS_NOT_RETURNED</ukg-checkbox>
          </ukg-label>
        </div>
      </div>
      <div *ngIf="enableFifteenDayAlertsAndNotifications" class="text-muted" data-automation="fund_type_ack_label" translate>ALERTS.FUND_FILTER_ACKNOWLEDGED_LABEL</div>
      <div *ngIf="enableFifteenDayAlertsAndNotifications" class="checkboxes-container">
        <div class="checkbox-container">
          <ukg-label for="acknowledged" translate data-automation="acknowledged_alert_status_label">
            <ukg-checkbox [disabled]="false" [fullWidth]="false" [roundedCorners]="true" translate id="acknowledged" [(ngModel)]="editFilters.hasAcknowledged" (change)="onAckChange()" data-automation="acknowledged_alert_status_checkbox">
            ALERTS.ACKNOWLEDGED</ukg-checkbox>
          </ukg-label>
        </div>
        <div class="checkbox-container">
          <ukg-label for="unAcknowledged" translate data-automation="not_acknowledged_alert_status_label">
            <ukg-checkbox [disabled]="false" [fullWidth]="false" [roundedCorners]="true" translate id="unAcknowledged" [(ngModel)]="editFilters.hasUnAcknowledged" data-automation="not_acknowledged_alert_status_checkbox">
            ALERTS.NOT_ACKNOWLEDGED</ukg-checkbox>
          </ukg-label>
        </div>
      </div>
    </div>
    <div *ngIf="showAckDates && enableFifteenDayAlertsAndNotifications" class="form-group comp-spacing fontstyling">
      <div class="text-muted" data-automation="from_ack_edit_label" translate>ALERTS.ACKNOWLEDGED_FROM</div>
      <ssg-date-picker [(ngModel)]="editFilters.ackFilter.fromAckDateTime"
        [minDate]="editFilters.minDate"
        [hasValidationError]="!editFilters.ackFilter.fromPrecedesTo"
        (invalidDateChanged)="editFilters.ackFilter.isFromDateInvalid = $event" justify="right"
        data-automation="ack_from_alerts_date_picker"></ssg-date-picker>
        <ukg-label *ngIf="displayFromAfterToErrorMessage && enableFifteenDayAlertsAndNotifications" class="text-danger" translate>EMPLOYEE_PAYS.FILTER_FROM_DATE_AFTER_TO_DATE</ukg-label>
    </div>
    <div *ngIf="showAckDates && enableFifteenDayAlertsAndNotifications" class="form-group comp-spacing fontstyling">
      <div class="text-muted" data-automation="to_ack_edit_label" translate>ALERTS.ACKNOWLEDGED_TO</div>
      <ssg-date-picker [(ngModel)]="editFilters.ackFilter.toAckDateTime"
        [minDate]="editFilters.minDate"
        [hasValidationError]="!editFilters.ackFilter.fromPrecedesTo"
        (invalidDateChanged)="editFilters.ackFilter.isToDateInvalid = $event" justify="right"
        data-automation="ack_to_alerts_date_picker"></ssg-date-picker>
    </div>
    <div class="form-group comp-spacing">
      <ukg-input-container [block]="true">
      <div class="text-muted" data-automation="payroll_type_edit_label" translate>ALERTS.PAYROLL_TYPE_LABEL</div>
        <ukg-select data-automation="payroll_type_edit_dropdown" [(ngModel)]="payrollType"
          bindLabel="localizedName" bindValue="value" [multiple]="false" [compareWith]="editFilters.payrollTypeCompareWith">
          <ukg-select-option *ngFor="let item of allPayrollTypes"  [value]="item.value" [label]="item.localizedName" ></ukg-select-option>
        </ukg-select>
      </ukg-input-container>
    </div>
    <div class="form-group comp-spacing">
      <ukg-input-container [block]="true">
      <div class="text-muted" data-automation="company_type_edit_label" translate>COMMON.COMPANY_LABEL</div>
        <ukg-select searchPlaceholder="{{ 'ALERTS.SEARCH_PLACEHOLDER' | translate}}" data-automation="company_type_edit_dropdown" [(ngModel)]="editFilters.componentCompany"
          bindLabel="legalName" bindValue="companyId" [multiple]="false">
          <ukg-select-option value="all" label="{{ 'COMMON.ALL' | translate }}" [selected]="true"></ukg-select-option>
          <ukg-select-option *ngFor="let item of allCompanies"  [value]="item.companyId" [label]="item.legalName" ></ukg-select-option>
        </ukg-select>
          </ukg-input-container>
    </div>
  </ssg-side-filter>
  </div>
  <div class="alert-details-main">
    <div class="alert-details-table-body flex-row flex-fill">
      <div *ngIf="notificationGroups && notificationGroups.length === 0" class="alert-details-group flex-column flex-center-center">
         <div class="text-muted text-no-data" data-automation="no_data_to_display_message"><strong translate>COMMON.NO_DATA_TO_DISPLAY</strong></div>
         <div class="text-muted text-no-data text-sm" translate data-automation="change_filter_criteria_message">COMMON.CHANGE_CRITERIA</div>
      </div>
      <!--Groups-->
      <div *ngIf="!enableEEPayPSGAlertUpdates && notificationGroups && notificationGroups.length > 0" class="alert-details-group flex-column">
        <div *ngFor='let notificationGroup of notificationGroups; let i = index'>
          <ssg-expander class="notification-group-expander" [open]="notificationGroup.expanded" (stateChanged)="sectionExpanded = $event" [expandable]="notificationGroup.hasData">
            <div expander-content class="expander-content">
              <div class="header-position" data-automation="notifications_group_label">
                {{ notificationGroup.groupKey.payUtcDate | ultishortdate:'L':true }}<!-- 
                --><span *ngIf="notificationGroup.groupKey.payGroup">{{ 'ALERTS.CUSTOMER_NOTIFICATION_GROUP_LABEL' | translate:{
                  payGroup: notificationGroup.groupKey.payGroup,
                  payrollType: notificationGroup.groupKey.payrollType | enum:'PayrollType' } }}
                </span>
                <ukg-icon name="help" class="clickable heading-icon-spacing" (click)="groupTooltip.present($event.target)" placement="right" data-automation="group_tooltip"></ukg-icon>
              </div>
            </div>
            <div expanded-content class="expanded-content">
              <ukg-data-table-container class="ssg_alerts_datatable">
                <ukg-data-table>
                  <table>
                    <thead>
                      <tr>
                        <ukg-th></ukg-th>
                        <ukg-th data-automation="employee_information_label" translate>ALERTS.RETURNS_EMP_INFO_COL</ukg-th>
                        <ukg-th data-automation="bank_exception_label">{{ 'ALERTS.RETURNS_BANK_EXC_DT_COL_LINE1' | translate }}  {{ 'ALERTS.RETURNS_BANK_EXC_DT_COL_LINE2' | translate }} <ukg-icon name="help" class="clickable heading-icon-spacing" (click)="exceptionDateTooltip.present($event.target)"  data-automation="bank_except_tooltip"></ukg-icon></ukg-th>
                        <ukg-th data-automation="bank_code_label">{{ 'ALERTS.RETURNS_BANK_CD_COL_LINE1' | translate }}  {{ 'ALERTS.RETURNS_BANK_CD_COL_LINE2' | translate }} <ukg-icon name="help" class="clickable heading-icon-spacing" (click)="bankCodeTooltip.present($event.target)" data-automation="bank_code_tooltip"></ukg-icon></ukg-th>
                        <ukg-th data-automation="bank_description_label">{{ 'ALERTS.RETURNS_BANK_DESC_COL_LINE1' | translate }}  {{ 'ALERTS.RETURNS_BANK_DESC_COL_LINE2' | translate }} <ukg-icon name="help" class="clickable heading-icon-spacing" (click)="bankDescriptionTooltip.present($event.target)" data-automation="bank_description_tooltip"></ukg-icon></ukg-th>
                        <ukg-th style="padding-left: 44px;" data-automation="recommended_action_label">{{ 'ALERTS.RETURNS_REC_ACTION_COL' | translate }} <ukg-icon name="help" class="clickable heading-icon-spacing" (click)="recommendedActionTooltip.present($event.target)" data-automation="recommended_action_tooltip"></ukg-icon></ukg-th>
                        <ukg-th></ukg-th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="fx-table-row" *ngFor='let notification of notificationGroup.notifications'>
                        <td><ssg-expander (stateChanged)="detailsExpanded(notification, $event)" data-automation="details_expander">
                            </ssg-expander>
                        </td>
                        <td><div data-automation="details_employee_name">{{notification.metadata.employeeName}}<br/></div>
                          <span class="text-muted" data-automation="details_employee_number">
                            {{ 'COMMON.EMPLOYEE_NUMBER' | translate: { employeeNumber: notification.metadata.employeeNumber } }}
                          </span>
                          <br/>
                          <ukg-chip selected *ngIf="notification.isPrenote" data-automation="details_prenote_chip">Prenote</ukg-chip>
                          <ng-container *ngIf="notification.showDetails" [ngTemplateOutlet]="getDetailsTemplate(notification.type)" [ngTemplateOutletContext]="{ 'details': notification.details }"></ng-container>
                        </td>
                        <td>
                          <div data-automation="details_applied_utc_date">{{notification.metadata.appliedUtcDateTime | ultishortdate: 'L'}}<br/></div>
                          <ng-container *ngIf="enableAlertDetailsNachaAuditInfo && notification.isNoc && notification.showDetails" [ngTemplateOutlet]="bankNotificationPayDetailsCol2" [ngTemplateOutletContext]="{ 'details': notification.details }"></ng-container>
                        </td>
                        <td>
                          <div data-automation="details_bank_code">{{notification.metadata.bankCode}}</div>
                        </td>
                        <td>
                          <div data-automation="details_bank_code_desc">{{translateBankCode(notification.metadata.bankCode)}}</div> 
                          <ng-container *ngIf="enableAlertDetailsNachaAuditInfo && notification.isNoc && notification.showDetails" [ngTemplateOutlet]="bankNotificationPayDetailsCol3" [ngTemplateOutletContext]="{ 'details': notification.details }"></ng-container>
                        </td>
                        <td style="min-width:400px;">
                          <ng-container *ngIf="notification.acknowledged; then acknowledged; else unacknowledged"></ng-container>
                          <ng-template #acknowledged>
                            <div style="display: flex;">
                            <ukg-icon name="status-finished" size="m" class="success-circle" data-automation="ack_success_circle"></ukg-icon>
                            <span translate data-automation="details_recommended_action">{{getRecommendedAction(notification)}}</span>
                            </div>
                          </ng-template>
                          <ng-template #unacknowledged>
                            <div style="display: flex;">
                            <ukg-icon name="warning" size="m" class="warning-triangle" data-automation="details_warning_triangle"></ukg-icon>
                            <span><strong translate data-automation="details_recommended_action">{{getRecommendedAction(notification)}}</strong></span>
                            </div>
                          </ng-template>
                        </td>
                        <td>
                          <span *ngIf="showAcknowledgeLink" class="clickable btn-link btn-alerts flex-start" (click)="setAcknowledged(notification.id, !notification.acknowledged)" data-automation="details_ack_link">
                            {{ notification.acknowledged ? acknowledgeButtonLabel(true) : acknowledgeButtonLabel(false) }}
                          </span>
                          <div *ngIf="enableFifteenDayAlertsAndNotifications && notification.acknowledged" class="flex-column flex-start">
                            <small class="text-muted alert-details-field" translate data-automation="details_ack_on_label">ALERTS.ACKNOWLEDGED_ON</small>
                            <strong><small translate
                                [translateParams]="{ date: notification.acknowledgedUtcDateTime | dateEst:'shortDate', time: notification.acknowledgedUtcDateTime | dateEst:'shortTime', zone: notification.acknowledgedUtcDateTime | estName }"
                                data-automation="details_ack_on">
                              COMMON.DATE_AT_TIME_EST
                            </small></strong>
                            <small class="text-muted alert-details-field" translate  data-automation="details_ack_by_label">ALERTS.ACKNOWLEDGED_BY</small>
                            <small data-automation="details_ack_by"><strong>{{notification.formattedAcknowledgedBy}}</strong></small>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </ukg-data-table>
              </ukg-data-table-container>
            </div>
          </ssg-expander>
        </div>
        <ukg-popover #groupTooltip>
            <p>{{ getGroupTooltip(selectedTab) | translate }}</p>
          </ukg-popover>
      </div>
      <!-- Groups Enhanced-->
      <div *ngIf="enableEEPayPSGAlertUpdates && notificationGroups && notificationGroups.length > 0" class="alert-details-group flex-column">
        <div *ngFor='let notificationGroup of notificationGroups; let i = index'>
          <ssg-expander class="notification-group-expander" [open]="notificationGroup.expanded" (stateChanged)="sectionExpanded = $event" [expandable]="notificationGroup.hasData">
            <div expander-content class="expander-content">
              <div class="header-position" data-automation="notifications_group_label">
                <ukg-label class="notification-group-label" type="primary">{{ 'ALERTS.PAYDATE_LABEL' | translate }}: {{ notificationGroup.groupKey.payUtcDate | ultishortdate:'L':true }}<!--
                --><span *ngIf="notificationGroup.groupKey.payGroup">{{ 'ALERTS.NOTIFICATION_GROUP_LABEL' | translate:{
                  payGroup: notificationGroup.groupKey.payGroup,
                  payrollType: notificationGroup.groupKey.payrollType | enum:'PayrollType' } }}
                </span></ukg-label>
                <ukg-icon name="help" class="clickable heading-icon-spacing" (click)="groupTooltip.present($event.target)" placement="right" data-automation="group_tooltip"></ukg-icon>
              </div>
            </div>
            <div expanded-content class="expanded-content">
              <ukg-data-table-container class="ssg_alerts_datatable">
                <ukg-data-table>
                  <table>
                    <thead>
                      <tr>
                        <ukg-th></ukg-th>
                        <ukg-th data-automation="employee_information_label"><ukg-label type="secondary" class="notification-table-header">{{'ALERTS.RETURNS_EMP_INFO_COL' | translate}}</ukg-label></ukg-th>
                        <ukg-th data-automation="bank_exception_label"><ukg-label type="secondary" class="notification-table-header">{{ 'ALERTS.BANK_ALERT_DATE_LABEL' | translate }}</ukg-label><ukg-icon name="help" class="clickable heading-icon-spacing" (click)="bankAlertDateTooltip.present($event.target)"  data-automation="bank_alert_date_tooltip"></ukg-icon></ukg-th>
                        <ukg-th data-automation="alert_type_label"><ukg-label type="secondary" class="notification-table-header">{{ 'ALERTS.ALERT_TYPE' | translate }}</ukg-label><ukg-icon name="help" class="clickable heading-icon-spacing" (click)="alertTypeTooltip.present($event.target)"  data-automation="alert_type_tooltip"></ukg-icon></ukg-th>
                        <ukg-th data-automation="bank_error_label"><ukg-label type="secondary" class="notification-table-header">{{ 'ALERTS.RETURNS_BANK_ERROR_LABEL' | translate }}</ukg-label><ukg-icon name="help" class="clickable heading-icon-spacing" (click)="bankErrorTooltip.present($event.target)"  data-automation="bank_error_tooltip"></ukg-icon></ukg-th>
                        <ukg-th data-automation="pay_status_label"><ukg-label type="secondary" class="notification-table-header">{{ 'ALERTS.PAY_STATUS_LABEL' | translate }}</ukg-label></ukg-th>
                        <ukg-th data-automation="recommended_action_label"><ukg-label type="secondary" class="notification-table-header">{{ 'ALERTS.REQUIRED_ACTION_LABEL' | translate }}</ukg-label><ukg-icon name="help" class="clickable heading-icon-spacing" (click)="alertRequiredActionTooltip.present($event.target)"  data-automation="alert_required_action_tooltip"></ukg-icon></ukg-th>
                        <ukg-th></ukg-th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="fx-table-row" *ngFor='let notification of notificationGroup.notifications'>
                        <td><ssg-expander (stateChanged)="detailsExpanded(notification, $event)" [open]="true" data-automation="details_expander">
                            </ssg-expander>
                        </td>
                        <td><div data-automation="details_employee_name">{{notification.metadata.employeeName}}<br/></div>
                          <span class="text-muted" data-automation="details_employee_number">
                            {{ 'COMMON.EMPLOYEE_NUMBER' | translate: { employeeNumber: notification.metadata.employeeNumber } }}
                          </span>
                          <br/>
                          <ukg-chip selected *ngIf="notification.isPrenote" data-automation="details_prenote_chip">Prenote</ukg-chip>
                          <ng-container *ngIf="notification.showDetails" [ngTemplateOutlet]="getDetailsTemplate(notification.type)" [ngTemplateOutletContext]="{ 'details': notification.details }"></ng-container>
                        </td>
                        <td>
                          <div data-automation="details_applied_utc_date">{{notification.metadata.effectiveUtcDateTime | ultishortdate: 'L'}}<br/></div>
                        </td>
                        <td>
                          <div data-automation="alert_type">{{getAlertTypeTranslationCode(notification.type) | translate}}</div>
                        </td>
                        <td>
                          <div data-automation="details_bank_code_desc">{{ notification.metadata.bankCode }} - {{translateBankCode(notification.metadata.bankCode)}}</div> 
                        </td>
                        <td>
                          <div data-automation="pay_status" class="nobr" style="display: flex;">
                            <ukg-icon name="warning" [ngClass]="getPayStatusIconClass(notification.type, notification.metadata.amount)" size="m" class="pay_status_warning-triangle" data-automation="pay_status_warning-triangle"></ukg-icon> <span class="span-with-icon">{{getPayStatusTranslationCode(notification.type, notification.metadata.amount) | translate}}</span>
                          </div><br/>
                          <span class="text-muted" data-automation="details_pay_status">
                            {{ getPayStatusDetailsTranslationCode(notification.type, notification.metadata.amount, notification.isPrenote) | translate }}
                          </span>
                        </td>
                        <td>
                            <span translate data-automation="details_recommended_action">{{getRecommendedAction(notification)}}<ukg-icon class="required-action-info-icon" name="info" size="m" data-automation="required_action_info_icon" (click)="requiredActionTooltip.present($event.target)" placement="bottom"></ukg-icon></span>
                            <div>
                              <table id="table-details-right">
                                <tr>
                                  <td>
                                    <ng-container *ngIf="enableAlertDetailsNachaAuditInfo && notification.isNoc && !notification.isPrenote && notification.showDetails" [ngTemplateOutlet]="bankNotificationPayDetailsCol2New" [ngTemplateOutletContext]="{ 'details': notification.details, 'originalAccountTypeDesc': getAccountTypeTranslationCode(notification.details?.accountType) }"></ng-container>
                                    <ng-container *ngIf="enableAlertDetailsNachaAuditInfo && (!notification.isNoc || notification.isPrenote) && notification.showDetails" [ngTemplateOutlet]="bankNotificationPayDetailsCol2NewWithAmount" [ngTemplateOutletContext]="{ 'details': notification.details, 'originalAccountTypeDesc': getAccountTypeTranslationCode(notification.details?.accountType) }"></ng-container>
                                  </td>
                                  <td>
                                    <ng-container *ngIf="enableAlertDetailsNachaAuditInfo && notification.isNoc && notification.showDetails" [ngTemplateOutlet]="bankNotificationPayDetailsCol3NewNoc" [ngTemplateOutletContext]="{ 'details': notification.details, 'bankProvidedAccountTypeDesc': getAccountTypeTranslationCode(notification.details?.bankProvidedAccountType) }"></ng-container>
                                  </td>
                                </tr>
                              </table>
                            </div>
                        </td>
                        <td>
                          <span *ngIf="showAcknowledgeLink" class="clickable btn-link btn-alerts flex-start" (click)="setAcknowledged(notification.id, !notification.acknowledged)" data-automation="details_ack_link">
                            {{ notification.acknowledged ? acknowledgeButtonLabel(true) : acknowledgeButtonLabel(false) }}
                          </span>
                          <div *ngIf="enableFifteenDayAlertsAndNotifications && notification.acknowledged" class="flex-column flex-start">
                            <small class="text-muted alert-details-field" translate data-automation="details_ack_on_label">ALERTS.ACKNOWLEDGED_ON</small>
                            <strong><small translate
                                [translateParams]="{ date: notification.acknowledgedUtcDateTime | dateEst:'shortDate', time: notification.acknowledgedUtcDateTime | dateEst:'shortTime', zone: notification.acknowledgedUtcDateTime | estName }"
                                data-automation="details_ack_on">
                              COMMON.DATE_AT_TIME_EST
                            </small></strong>
                            <small class="text-muted alert-details-field" translate  data-automation="details_ack_by_label">ALERTS.ACKNOWLEDGED_BY</small>
                            <small data-automation="details_ack_by"><strong>{{notification.formattedAcknowledgedBy}}</strong></small>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </ukg-data-table>
              </ukg-data-table-container>
            </div>
          </ssg-expander>
        </div>
        <ukg-popover #groupTooltip>
            <p>{{ getGroupTooltip(selectedTab) | translate }}</p>
        </ukg-popover>
        <ukg-popover #requiredActionTooltip>
          <p>{{ 'ALERTS.REQUIRED_ACTION_TOOLTIP' | translate }}</p>
        </ukg-popover>
      </div>
    </div>
  </div>
</div>

  <ukg-popover #exceptionDateTooltip>
    <p data-automation="bank_exception_tooltip_text" translate>ALERTS.TOOLTIP_BANK_EXCEPTION_DATE</p>
  </ukg-popover>  
  <ukg-popover #bankCodeTooltip>
    <p data-automation="bank_code_tooltip_text" translate>ALERTS.TOOLTIP_BANK_CODE</p>
  </ukg-popover>
  <ukg-popover #bankDescriptionTooltip>
    <p data-automation="bank_description_tooltip_text" translate>ALERTS.TOOLTIP_BANK_DESCRIPTION</p>
  </ukg-popover>
  <ukg-popover #recommendedActionTooltip>
    <p data-automation="recommended_action_tooltip_text" translate>ALERTS.TOOLTIP_RECOMMENDED_ACTION</p>
  </ukg-popover>  

  <ukg-popover #bankAlertDateTooltip>
    <p data-automation="bank_alert_date_tooltip_text" translate>ALERTS.TOOLTIP_BANK_ALERT_DATE</p>
  </ukg-popover>
  <ukg-popover #alertTypeTooltip>
    <p data-automation="noc_alert_type_tooltip_text" translate>ALERTS.TOOLTIP_NOC_ALERT_TYPE</p>
    <p data-automation="return_alert_type_tooltip_text" translate>ALERTS.TOOLTIP_RETURN_ALERT_TYPE</p>
    <p data-automation="reject_alert_type_tooltip_text" translate>ALERTS.TOOLTIP_REJECT_ALERT_TYPE</p>
  </ukg-popover>
  <ukg-popover #bankErrorTooltip>
    <p data-automation="bank_error_tooltip_text" translate>ALERTS.TOOLTIP_BANK_ERROR</p>
  </ukg-popover>
  <ukg-popover #alertRequiredActionTooltip>
    <p data-automation="alert_required_action_tooltip_text" translate>ALERTS.TOOLTIP_REQUIRED_ACTION</p>
  </ukg-popover>

<ng-template #bankNotificationPayDetails let-details="details">
  <div class="alert-details-field details-extra-columns3">
    <small class="text-muted" translate>COMMON.AMOUNT</small>
    <small><strong><ssg-currency [amount]="details?.netAmount" [showFullAmount]="true" placement="left" class="flex-start"></ssg-currency></strong></small>
  </div>
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.ACCOUNT_ROUTING_NUMBER</small></div>
    <small><strong>{{details ? ('ALERTS.ACCOUNT_ROUTING_NUMBER_VALUES' | translate:{ accountNumber: details?.accountNumberMasked, routingNumber: details?.routingNumber}) : ''}}</strong></small>
  </div>
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.COMPANY_NAME</small></div>
    <small><strong>{{details?.companyName}}</strong></small>
  </div>
</ng-template>

<ng-template #bankNotificationPayDetailsCol2 let-details="details">
  <div class="alert-details-field details-extra-columns2">
    <div><small class="text-muted" translate>ALERTS.COMPANY_IDENTIFICATION</small></div>
    <small><strong>{{details?.companyIdentification}}</strong></small>
  </div>
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.COMPANY_DESCRIPTION</small></div>
    <small><strong>{{details?.companyEntryDescription}}</strong></small>
  </div>
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.INDIVIDUAL_NAME</small></div>
    <small><strong>{{details?.individualName}}</strong></small>
  </div>
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.INDIVIDUAL_ID_NUMBER</small></div>
    <small><strong>{{details?.individualIdNumber}}</strong></small>
  </div>
</ng-template>

<ng-template #bankNotificationPayDetailsCol3 let-details="details">
  <div class="alert-details-field details-extra-columns">
    <div><small class="text-muted" translate>ALERTS.EFFECTIVE_ENTRY_DATE</small></div>
    <small><strong>{{getEffectiveEntryDate(details?.effectiveEntryDate) | ultishortdate:'L':true}}</strong></small>
  </div>
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.ORIGINAL_ENTRY_TRACE_NUMBER</small></div>
    <small><strong>{{details?.originalEntryTraceNumber}}</strong></small>
  </div>
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.DFI_ACCOUNT_NUMBER</small></div>
    <small><strong>{{details?.dfiAccountNumber}}</strong></small>
  </div>
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.ORIGINAL_RDFI_NUMBER</small></div>
    <small><strong>{{details?.originalRdfiIdentification}}</strong></small>
  </div>
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.CORRECTED_DATA</small></div>
    <small><strong>{{details?.correctedData}}</strong></small>
  </div>
</ng-template>

<ng-template #bankNotificationPayDetailsNew let-details="details">
  <div class="alert-details-field details-extra-columns3">
    <div><small class="text-muted" translate>ALERTS.COMPANY_NAME</small></div>
    <small><strong>{{details?.companyName}}</strong></small>
  </div>
</ng-template>

<ng-template #bankNotificationPayDetailsCol2New let-details="details" let-originalAccountTypeDesc="originalAccountTypeDesc">
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.ALERT_DETAILS_ORIGINAL_LABEL</small></div>
  </div>
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.ACCOUNT_ROUTING_NUMBER_LABEL</small></div>
    <small><strong>{{details?.routingNumber}}&nbsp;</strong></small>
  </div>
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.ACCOUNT_NUMBER_LABEL</small></div>
    <small><strong>{{details?.accountNumber}}&nbsp;</strong></small>
  </div>
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.ACCOUNT_TYPE_LABEL</small></div>
    <small><strong translate>{{originalAccountTypeDesc}}&nbsp;</strong></small>
  </div>
</ng-template>

<ng-template #bankNotificationPayDetailsCol2NewWithAmount let-details="details" let-originalAccountTypeDesc="originalAccountTypeDesc">
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.ALERT_DETAILS_ORIGINAL_LABEL</small></div>
  </div>
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.ACCOUNT_ROUTING_NUMBER_LABEL</small></div>
    <small><strong>{{details?.routingNumber}}&nbsp;</strong></small>
  </div>
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.ACCOUNT_NUMBER_LABEL</small></div>
    <small><strong>{{details?.accountNumber}}&nbsp;</strong></small>
  </div>
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.ACCOUNT_TYPE_LABEL</small></div>
    <small><strong translate>{{originalAccountTypeDesc}}&nbsp;</strong></small>
  </div>
  <div class="alert-details-field">
    <small class="text-muted" translate>COMMON.AMOUNT</small>
    <small><strong><ssg-currency [amount]="details?.netAmount" [showFullAmount]="true" placement="left" class="flex-start"></ssg-currency>&nbsp;</strong></small>
  </div>
</ng-template>

<ng-template #bankNotificationPayDetailsCol3NewNoc let-details="details" let-bankProvidedAccountTypeDesc="bankProvidedAccountTypeDesc">
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.ALERT_DETAILS_CHANGE_TO_LABEL</small></div>
  </div>
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.BANK_PROVIDED_ROUTING_NUMBER_LABEL</small></div>
    <small><strong>{{details?.bankProvidedRoutingNumber}}&nbsp;</strong></small>
  </div>
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.BANK_PROVIDED_ACCOUNT_NUMBER_LABEL</small></div>
    <small><strong>{{details?.bankProvidedAccountNumber}}&nbsp;</strong></small>
  </div>
  <div class="alert-details-field">
    <div><small class="text-muted" translate>ALERTS.BANK_PROVIDED_ACCOUNT_TYPE_LABEL</small></div>
    <small><strong translate>{{bankProvidedAccountTypeDesc}}&nbsp;</strong></small>
  </div>  
</ng-template>
